export default "__VITE_ASSET__2582a049__"